/* eslint-disable */
export const templateCard = (data) => {
	const { title, excerpt, image, permalink, date } = data;
	return /* html */`
	<article>
		<a href="${permalink}" class="flex flex-col h-full gap-4 text-center group/link">
			<figure class="relative overflow-hidden h-[390px] before:bg-yellow before:absolute before:inset-0 before:z-10 lg:before:opacity-0 before:transition-opacity before:duration-300 before:ease-in-out before:opacity-80 lg:group-hover/link:before:opacity-80">
			<img src="${image}" alt="${title}" class="transition duration-700 ease-in-out group-hover/link:scale-110 object-cover object-center w-full h-full">
				<figcaption class="absolute inset-0 z-20 flex items-center justify-center p-4 font-semibold text-white transition-opacity duration-300 ease-in-out lg:opacity-0 lg:group-hover/link:opacity-100">
					${excerpt}
				</figcaption>
			</figure>
			<span class="relative uppercase text-sm font-bold monospace-font before:h-14 before:w-[1px] group-hover/link:before:bg-yellow-light before:bg-[#E6E4D1] before:block before:transform before:translate-x-[-50%] before:-translate-y-16 before:absolute before:top before:left-1/2 transition-all group-hover/link:-translate-y-2 mt-4">${date}</span>
			<h3 class="font-semibold uppercase text-center py-0 text-2xl headlines-font text-brown transition-all group-hover/link:-translate-y-2">${title}</h3>
			<span class="mt-auto text-sm font-bold uppercase transition-all text-yellow group-hover/link:-translate-y-2">view more</span>
		</a>
	</article>
	`;
}
const getBlogPosts = async (config) => {
	const formData = new FormData()
	const { url, nonce } = theme.config
	formData.append('action', theme.actions.get_blog_posts)
	formData.append('nonce', nonce)
	formData.append('config', JSON.stringify(config))
	try {
		const response = await fetch(url, {
			method: 'POST',
			body: formData
		})
		return response;
	} catch (error) {
		console.log(error)
	}
}

const loadPosts = ({ posts, fromZero = false }) => {
	const container = document.querySelector('[ref="response"]');
	if (fromZero) {
		container.innerHTML = ''
	}
	posts.length ? posts.forEach(post => {
		const card = templateCard(post)
		container.insertAdjacentHTML('beforeend', card)
	}) : (container.innerHTML = '<p class="text-center py-12 font-semibold">Posts not found</p>')
}
const loadMorePosts = ({ paged, max_num_pages }) => {
	const loadMore = document.querySelector('[ref="loadMore"]');

	loadMore.setAttribute('data-paged', paged)
	loadMore.setAttribute('data-max-num-pages', max_num_pages)
	if (paged >= max_num_pages) {
		loadMore.setAttribute('disabled', 'true')
		loadMore.classList.add('hidden')
	}
}

export const initBlog = () => {
	const formBlog = document.getElementById('formBlog');
	const filters = formBlog && formBlog.querySelectorAll('[name="categories"]');
	filters && filters.forEach(filter => {
		filter.addEventListener('change', e => {
			const target = e.target.value;
			const loadMore = document.querySelector('[ref="loadMore"]');
			if (loadMore) {
				loadMore.setAttribute('data-paged', 1)
				loadMore.removeAttribute('disabled')
				loadMore.classList.remove('hidden')
			}

			getBlogPosts({ filter: target }).then(result => {
				if (!result.ok) throw new Error(result.message)
				return result.json();
			}).then(res => {
				const { data } = res;
				const { paged, max_num_pages, posts } = data;
				loadMorePosts({ paged, max_num_pages })
				loadPosts({ posts, fromZero: true })
			}).catch(error => {
				console.log(error)
			})
		})
	})

	const loadMore = document.querySelector('[ref="loadMore"]');
	loadMore && loadMore.addEventListener('click', e => {
		loadMore.setAttribute('disabled', 'true')
		e.preventDefault()
		const paged = loadMore.getAttribute('data-paged');
		const perPage = loadMore.getAttribute('data-per-page');
		getBlogPosts({ paged, perPage }).then(result => {
			if (!result.ok) throw new Error(result.message)
			return result.json();
		}).then(res => {
			const { data } = res;
			const { paged, max_num_pages, posts } = data;
			loadMorePosts({ paged, max_num_pages })
			loadPosts({ posts })
		}).catch(error => {
			console.log(error)
		}).finally(() => {
			if (loadMore.getAttribute('data-paged') < loadMore.getAttribute('data-max-num-pages')) {
				loadMore.removeAttribute('disabled')
			}
		})
	})
}